export default "__VITE_ASSET__D8LLp3VG__"